const mediaQueries = {
  small: '(max-width: 480px)',
  medium: '(max-width: 768px)',
  large: '(min-width: 769px)',
};

let requiredImage;
const windowWidth = window.innerWidth;

if (window.matchMedia(mediaQueries.small).matches) {
  requiredImage = 'small';
} else if (window.matchMedia(mediaQueries.medium).matches) {
  requiredImage = 'medium';
} else if (window.matchMedia(mediaQueries.large).matches) {
  requiredImage = 'large';
}

const initialiseStyleBackgroundIntersectionObserver = () => {
  const lazyBackgrounds = Array.from(document.querySelectorAll('[data-bg]'));

  if (lazyBackgrounds.length === 0) {
    return;
  }

  let lazyBackgroundObserver;

  const loadBackgroundIfElementOnScreen = (entry) => {
    const imagesArray = JSON.parse(entry.target.dataset.bg);
    const imageToSet = `${imagesArray[requiredImage].src}&width=${windowWidth}`;

    if (!entry.isIntersecting) {
      return;
    }

    entry.target.style.backgroundImage = `url('${imageToSet}')`;
    lazyBackgroundObserver.unobserve(entry.target);
  };

  const observeElementVisibility = (lazyBackground) => {
    lazyBackgroundObserver.observe(lazyBackground);
  };

  const setBackground = (entry, element) => {
    const imagesArray = JSON.parse(entry.target.dataset.bg);
    const imageToSet = `${imagesArray[requiredImage].src}&width=${windowWidth}`;
    element.style.backgroundImage = `url('${imageToSet}')`;
  };

  if (typeof window.IntersectionObserver === 'function') {
    lazyBackgroundObserver = new IntersectionObserver((entries) => {
      entries.forEach(loadBackgroundIfElementOnScreen);
    });
    lazyBackgrounds.forEach(observeElementVisibility);
  } else {
    lazyBackgrounds.forEach(setBackground);
  }
};

if (typeof document.readyState === 'string' && document.readyState === 'complete') {
  initialiseStyleBackgroundIntersectionObserver();
} else {
  document.addEventListener('DOMContentLoaded', initialiseStyleBackgroundIntersectionObserver, true);
}
